function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".secure-data_svg__e,.secure-data_svg__f{fill:#fff}.secure-data_svg__c,.secure-data_svg__d{fill:none}.secure-data_svg__c,.secure-data_svg__d,.secure-data_svg__f{stroke:#2196f3}.secure-data_svg__c,.secure-data_svg__d,.secure-data_svg__e{stroke-linecap:round}.secure-data_svg__c,.secure-data_svg__d,.secure-data_svg__e,.secure-data_svg__f{stroke-width:2px}.secure-data_svg__d,.secure-data_svg__e{stroke-linejoin:round}.secure-data_svg__e{stroke:#1d1f2c}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.739 68.838a22.994 22.994 0 010-32.525L36.313 8.739A23 23 0 1168.84 41.264L41.264 68.838a22.994 22.994 0 01-32.525 0z",
  fill: "#2196f3",
  opacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-99.76 -24)"
}, /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__c",
  d: "M144.761 59v9"
}), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__d",
  d: "M141.532 61.781l3.135-3.135 3.135 3.135"
}), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__c",
  d: "M133.761 62.647v-9"
}), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__d",
  d: "M130.532 59.866l3.135 3.135 3.135-3.135"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.24 -6)"
}, /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__e",
  d: "M128 61v-.018A7.5 7.5 0 01128.5 46c.17 0 .338.006.506.018a11.5 11.5 0 0121.023-5.953 6.925 6.925 0 01.971-.068 7 7 0 016.3 10.063 5.5 5.5 0 01-.3 10.918v.023z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "secure-data_svg__f",
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(137 42)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(134 47)",
  strokeLinejoin: "round",
  strokeWidth: 2,
  strokeLinecap: "round",
  stroke: "#2196f3",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__c",
  d: "M141 52.734V51"
})), /*#__PURE__*/React.createElement("path", {
  d: "M150.093 71h5.334a1.333 1.333 0 011.333 1.333V89a4 4 0 01-4 4h0a4 4 0 01-4-4V72.333A1.333 1.333 0 01150.093 71z",
  stroke: "#707070",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.76 67h27a1 1 0 011 1v21a4 4 0 01-4 4h-24a1 1 0 01-1-1V68a1 1 0 011-1z",
  stroke: "#1d1f2c",
  strokeWidth: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__e",
  d: "M152.634 93.004h-26.87a6.009 6.009 0 01-6-6V73.66h17.465l2.625-2.625h8.912v17.967a4 4 0 003.875 4v.006z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secure-data_svg__f",
  d: "M133.76 82h1a4 4 0 014 4v1a1 1 0 01-1 1h-7a1 1 0 01-1-1v-1a4 4 0 014-4z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "secure-data_svg__f",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  transform: "translate(131.76 77)"
}));

var SvgSecureData = function SvgSecureData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgSecureData as ReactComponent };